import React from "react"
import { MainCP } from "../../Components/confianza-empresa-cep/MainCP"

const ViewConfianzaCep: React.FC = () => <MainCP/>

export default ViewConfianzaCep